import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user_id: null,
  user_name: null,
  user_firstName: null,
  user_lastName: null,
  user_email: null,
  user_phone: null,
  user_bu: null,
  user_division: null,

  user_edit: false,
  bu_edit: false,

  userIsPane: false,
  adduserIsPane: false,

  user_filter: true,
  user_editroleid: null,
};

export const userReducerInner = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    user_id(state, action) {
      state.user_id = action.payload;
    },
    user_name(state, action) {
      state.user_name = action.payload;
    },
    user_firstName(state, action) {
      state.user_firstName = action.payload;
    },
    user_lastName(state, action) {
      state.user_lastName = action.payload;
    },
    user_email(state, action) {
      state.user_email = action.payload;
    },
    user_phone(state, action) {
      state.user_phone = action.payload;
    },
    user_bu(state, action) {
      state.user_bu = action.payload;
    },
    user_division(state, action) {
      state.user_division = action.payload;
    },
    user_editroleid(state, action) {
      state.user_editroleid = action.payload;
    },
    user_edit(state, action) {
      state.user_edit = action.payload;
    },
    bu_edit(state, action) {
      state.bu_edit = action.payload;
    },
    user_IsPane(state, action) {
      state.userIsPane = action.payload;
    },
    adduser_IsPane(state, action) {
      state.adduserIsPane = action.payload;
    },
    user_filter(state, action) {
      state.user_filter = action.payload;
    },
  },
});
